import followUpByBoard from '@/app/dashboard-tv/store/follow-up-by-board'
import byDueDate from './store/by-due-date'

export default {
  followUpByBoard,
  byDueDate
}
